import { create } from 'zustand';
import { ContactStoreType } from '../types/dialer-body/contacts.types';

const defaultValues = {
  searchQuery: '',
  selectedContactId: null,
  mode: null,
};

export const useContactStore = create<ContactStoreType>((set) => ({
  ...defaultValues,
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setSelectedContactId: (selectedContactId) => set({ selectedContactId }),
  setMode: (mode) => set({ mode }),
  closeMode: () => set({ mode: null }),
  resetContactIdAndMode: () => set({ mode: null, selectedContactId: null }),
  resetContact: () => set({ ...defaultValues }),
}));
